var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-documents-item"},[_c('div',{staticClass:"plugin-documents-item__icon"},[_c('icon',{attrs:{"name":"document"}})],1),_c('div',{staticClass:"plugin-documents-item__title",domProps:{"textContent":_vm._s(_vm.item.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }